<ng-template #contentBody>
  <div class="dialog-header">
    <div class="header-icon-wrapper">
      <i class="fas fa-folder-open" aria-hidden="true"></i>
    </div>
    <h3 id="token-content-modal-title" tabindex="-1" cdkFocusInitial>Contenido del token</h3>
  </div>

  <div class="token-content-body">
    <p class="result-message" *ngIf="viewData.message">{{ viewData.message }}</p>

    <p class="label-certificates" *ngIf="viewData.certificates?.length">
      Certificados en el token ({{ viewData.certificates.length }})
    </p>
    <div class="certificate-list" *ngIf="viewData.certificates?.length">
      <div
        class="certificate-item cert-card"
        *ngFor="let cert of viewData.certificates; let i = index"
        role="article"
        [attr.aria-label]="'Certificado ' + (i + 1) + ': ' + displayName(cert)">
        <div class="cert-card-header">
          <p class="certificate-title">{{ displayName(cert) }}</p>
          <span class="certificate-badge badge-caducado" *ngIf="isExpired(cert.notAfter)">
            Certificado caducado
          </span>
          <span class="certificate-badge badge-vigente" *ngIf="!isExpired(cert.notAfter) && cert.notAfter">
            Vigente
          </span>
        </div>

        <div class="cert-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            [attr.aria-selected]="getActiveTab(i) === 0"
            [class.active]="getActiveTab(i) === 0"
            (click)="setActiveTab(i, 0)">
            General
          </button>
          <button
            type="button"
            role="tab"
            [attr.aria-selected]="getActiveTab(i) === 1"
            [class.active]="getActiveTab(i) === 1"
            (click)="setActiveTab(i, 1)">
            Titular y emisor
          </button>
          <button
            type="button"
            role="tab"
            [attr.aria-selected]="getActiveTab(i) === 2"
            [class.active]="getActiveTab(i) === 2"
            (click)="setActiveTab(i, 2)">
            Técnico
          </button>
          <button
            type="button"
            role="tab"
            [attr.aria-selected]="getActiveTab(i) === 3"
            [class.active]="getActiveTab(i) === 3"
            (click)="setActiveTab(i, 3)">
            Token
          </button>
        </div>

        <div class="tab-panes">
          <div class="tab-pane" *ngIf="getActiveTab(i) === 0" role="tabpanel">
            <dl class="certificate-data-list">
              <dt>Emisor</dt>
              <dd>{{ extractIssuerName(cert.issuer) || '—' }}</dd>
              <dt>Número de serie</dt>
              <dd class="cert-value-monospace">{{ cert.serialNumber || '—' }}</dd>
              <dt>Válido desde</dt>
              <dd>{{ formatDate(cert.notBefore) || '—' }}</dd>
              <dt>Válido hasta</dt>
              <dd [class.cert-expired]="isExpired(cert.notAfter)">{{ formatDate(cert.notAfter) || '—' }}</dd>
            </dl>
          </div>
          <div class="tab-pane" *ngIf="getActiveTab(i) === 1" role="tabpanel">
            <p class="cert-field-label">Subject (titular)</p>
            <ul class="dn-list" *ngIf="parseDN(cert.subject).length; else emptySubject">
              <li class="dn-item" *ngFor="let item of parseDN(cert.subject)">
                <span class="dn-key" *ngIf="item.key">{{ item.key }}:</span>
                <span class="dn-value">{{ item.value }}</span>
              </li>
            </ul>
            <ng-template #emptySubject><p class="dn-empty">—</p></ng-template>
            <p class="cert-field-label">Issuer (emisor)</p>
            <ul class="dn-list" *ngIf="parseDN(cert.issuer).length; else emptyIssuer">
              <li class="dn-item" *ngFor="let item of parseDN(cert.issuer)">
                <span class="dn-key" *ngIf="item.key">{{ item.key }}:</span>
                <span class="dn-value">{{ item.value }}</span>
              </li>
            </ul>
            <ng-template #emptyIssuer><p class="dn-empty">—</p></ng-template>
          </div>
          <div class="tab-pane" *ngIf="getActiveTab(i) === 2" role="tabpanel">
            <dl class="certificate-data-list">
              <dt>Número de serie</dt>
              <dd class="cert-value-monospace">{{ cert.serialNumber || '—' }}</dd>
              <dt>Thumbprint</dt>
              <dd class="cert-value-monospace">{{ cert.thumbprint || '—' }}</dd>
              <dt>Label</dt>
              <dd>{{ cert.label || '—' }}</dd>
              <dt>Válido desde</dt>
              <dd>{{ formatDate(cert.notBefore) || '—' }}</dd>
              <dt>Válido hasta</dt>
              <dd [class.cert-expired]="isExpired(cert.notAfter)">{{ formatDate(cert.notAfter) || '—' }}</dd>
            </dl>
          </div>
          <div class="tab-pane" *ngIf="getActiveTab(i) === 3" role="tabpanel">
            <ng-container *ngIf="viewData.tokenDetails; else noTokenDetails">
              <dl class="certificate-data-list">
                <dt>Label</dt>
                <dd>{{ viewData.tokenDetails!.label || '—' }}</dd>
                <dt>Fabricante</dt>
                <dd>{{ viewData.tokenDetails!.manufacturer || '—' }}</dd>
                <dt>Modelo</dt>
                <dd>{{ viewData.tokenDetails!.model || '—' }}</dd>
                <dt>Número de serie</dt>
                <dd class="cert-value-monospace">{{ viewData.tokenDetails!.serialNumber || '—' }}</dd>
                <dt>Memoria total</dt>
                <dd>{{ viewData.tokenDetails!.totalMemory != null ? (viewData.tokenDetails!.totalMemory | number) + ' bytes' : '—' }}</dd>
                <dt>Memoria libre</dt>
                <dd>{{ viewData.tokenDetails!.freeMemory != null ? (viewData.tokenDetails!.freeMemory | number) + ' bytes' : '—' }}</dd>
                <dt>Long. máx. PIN</dt>
                <dd>{{ viewData.tokenDetails!.maxPinLen != null ? viewData.tokenDetails!.maxPinLen : '—' }}</dd>
                <dt>Long. mín. PIN</dt>
                <dd>{{ viewData.tokenDetails!.minPinLen != null ? viewData.tokenDetails!.minPinLen : '—' }}</dd>
                <dt>Versión hardware</dt>
                <dd>{{ viewData.tokenDetails!.hardwareVersion || '—' }}</dd>
                <dt>Versión firmware</dt>
                <dd>{{ viewData.tokenDetails!.firmwareVersion || '—' }}</dd>
              </dl>
            </ng-container>
            <ng-template #noTokenDetails>
              <p class="no-token-details">No hay información del token disponible.</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <p class="no-certificates" *ngIf="!viewData.certificates?.length">
      No hay certificados en el token.
    </p>

    <div class="button-container">
      <button type="button" class="btn btn-primary" (click)="close()" aria-label="Cerrar">
        Cerrar
      </button>
    </div>
  </div>
</ng-template>

<div *ngIf="!embedded" mat-dialog-content role="dialog" aria-modal="true" aria-labelledby="token-content-modal-title">
  <ng-container *ngTemplateOutlet="contentBody"></ng-container>
</div>
<div *ngIf="embedded" class="tf-admin-step-panel token-content-result-embedded" role="region" aria-labelledby="token-content-modal-title">
  <ng-container *ngTemplateOutlet="contentBody"></ng-container>
</div>
